import { Store } from '../../../types';
import { getLangVar } from '../../../util/misc';

export default function StoreCard({ store }: { store: Store }) {
    const address = getLangVar(store, 'address') || '';
    const phone = getLangVar(store, 'phone') || '';
    const email = getLangVar(store, 'email') || '';
    const workHours = getLangVar(store, 'workHours') || '';
    return (
        <div className="col-md-6 mt-2 gmap-desc" style={{ minHeight: '200px' }}>
            <div className="gmap-cap">
                <strong>{getLangVar(store, 'name')}</strong>
            </div>
            {address && (
                <div className="gmap-text">
                    <span> Адрес: </span>
                    {address}
                </div>
            )}
            {store.address && !address && (
                <div className="gmap-text">
                    <span> Адрес: </span>
                    {store.address}
                </div>
            )}
            {workHours && (
                <div className="gmap-text">
                    <span> Время работы: </span>
                    {workHours}
                </div>
            )}
            {phone && (
                <div className="gmap-text">
                    <span> Телефон: </span>
                    <a href={`tel:${phone}`}>{phone}</a>
                </div>
            )}
            {store.url && (
                <div className="gmap-text">
                    <span> Сайт: </span>
                    <a href={store.url} target="_blank" rel="noreferrer">
                        {store.url}
                    </a>
                </div>
            )}
            {email && (
                <div className="gmap-text">
                    <span> Email: </span>
                    <a href={`mailto:${email}`} target="_blank" rel="noreferrer">
                        {email}
                    </a>
                </div>
            )}
        </div>
    );
}
